export type StatusType =
  "normal" | "caution" | "critical" | "default" | "neutral"

export const mapColorNameToStatus = (colorName: string): StatusType => {
  switch (colorName) {
    case "yellow":
      return "caution"
    case "green":
      return "normal"
    case "red":
      return "critical"
    case "grey":
      return "default"
    default:
      return "neutral"
  }
}

export type StatusObject = {
  [key in StatusType]: string
}

export interface IStatus {
  type: StatusType
  text: string
}

export class Status implements IStatus {
  readonly type: StatusType
  readonly text: string

  constructor(type: StatusType, text: string) {
    this.type = type
    this.text = text
  }
}
